const priceAccordion = () => {
    const classes = {
        accordionOpen: 'price-accordion--open',
    };
    const selectors = {
        priceAccordion: '[data-price-accordion]',
        priceAccordionToggle: '[data-price-accordion-toggle]',
        priceAccordionContent: '[data-price-accordion-content]',
    };
    const priceAccordions = document.querySelectorAll(selectors.priceAccordion);
    priceAccordions.forEach((accordion) => {
        const toggle = accordion.querySelector(selectors.priceAccordionToggle);
        const content = accordion.querySelector(selectors.priceAccordionContent);
        const openAccordion = (accordion) => {
            const content = accordion.querySelector(selectors.priceAccordionContent);
            accordion.classList.add(classes.accordionOpen);
            content.style.maxHeight = content.scrollHeight + 'px';
        };
        const closeAccordion = (accordion) => {
            const content = accordion.querySelector(selectors.priceAccordionContent);
            accordion.classList.remove(classes.accordionOpen);
            content.style.maxHeight = null;
        };
        if (toggle) {
            toggle.addEventListener('click', () => {
                if (content.style.maxHeight) {
                    closeAccordion(accordion);
                }
                else {
                    openAccordion(accordion);
                }
            });
        }
    });
};
export { priceAccordion };
